export default {
  title: 'Dashboard',
  totalOrders: 'Total Orders',
  totalWeight: 'Total Weight',
  totalRevenue: 'Total Revenue',
  totalProfit: 'Total Profit',
  todayOrders: 'Today Orders',
  pendingOrders: 'Pending Orders',
  recentOrders: 'Recent Orders',
  orderTrend: 'Order Trend',
  profitTrend: 'Profit Trend',
  topCustomers: 'Top Customers',
  topRoutes: 'Top Routes',
  todayConsignments: 'Today Consignments',
  totalWeightKG: 'Total Weight (KG)',
  grossProfitRate: 'Gross Profit Rate',
  businessCalendar: 'Business Calendar',
  monthFormat: '{y}-{m}',
  consignmentShort: 'Cons:',
  mawbShort: 'MAWB:',
  weightShort: 'Wt:',
  airlineDistribution: 'Airline Cargo Distribution',
  grossProfit: 'Gross Profit',
  airlineShort: 'Airline:',
  noDayData: 'No business data for this day',
  businessDetail: 'Business Detail',
  orderCount: 'Orders',
  profit: 'Profit',
  airlineCargo: 'Airline Cargo',
  unknown: 'Unknown',
  weekDaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekDaysLong: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  fetchStatsFailed: 'Failed to fetch statistics',
  fetchTrendFailed: 'Failed to fetch trend data',
  fetchRouteFailed: 'Failed to fetch route distribution',
  fetchCalendarFailed: 'Failed to fetch calendar data',
  initTrendChartFailed: 'Failed to initialize trend chart',
  initRouteChartFailed: 'Failed to initialize route chart',
  // businessOrders page stats
  totalBizOrders: 'Total Biz Orders',
  totalSalesGrossProfit: 'Total Sales Gross Profit',
  totalProductGrossProfit: 'Total Product Gross Profit',
  // productOrderRecord page stats
  filterResult: 'Filter Result',
  totalSalesRevenue: 'Total Revenue',
  totalCost: 'Total Cost',
  totalGrossProfit: 'Total Gross Profit',
  avgMargin: 'Avg. Margin',
  currencySymbol: '¥',
  weightUnit: 'KG',
  weightUnitShort: 'KGS',
}
